import { useLocation } from 'react-router';

export default function useIsTemplateMenu() {
  const location = useLocation();
  const path = location.pathname;
  return path.includes('shared_menu');
}
